import { useMediaLibrary } from "../MediaLibraryContext"
import { SidepaneContainer } from "./components/SidepaneContainer"
import { SidepaneContent } from "./SidepaneContent"

export function Sidepane() {
  const { selectedMediaIds } = useMediaLibrary()
  const hasSelectedMedia = selectedMediaIds.size > 0

  return (
    <SidepaneContainer hasSelectedMedia={hasSelectedMedia}>
      <SidepaneContent />
    </SidepaneContainer>
  )
}
